import React from 'react';
import NRActionModal from '../../NRActionModal/NRActionModal';
import { useContext } from 'react';
import { RemediationContext } from '../NRRemediationContext';
import NRRemediationContent from '../NRRemediationContent/NRRemediationContent';

function NRRemediationModal() {
  const { openRemediationModal, setOpenRemediationModal, rows, content, title } = useContext(RemediationContext);
  const handleClose = () => {
    setOpenRemediationModal(false);
  };

  return (
    <NRActionModal
      title={rows.length && !title ? `Remediate Issues - ${rows.length}` : title}
      actionLabel={'confirmActionLabel'}
      cancelLabel={'cancelActionLabel'}
      content={content}
      open={openRemediationModal}
      handleClose={handleClose}
      width={500}
    />
  );
}

export default NRRemediationModal;
